// CHEAT SHEET: https://gist.github.com/mrmartineau/a4b7dfc22dc8312f521b42bb3c9a7c1e
import AdvancedController from "./advanced-controller";
import Swiper, { Pagination, EffectFade, Autoplay } from "swiper";

import gsap from "gsap";
import { Breakpoints } from "../utils/breakpoints";

export default class SiStepsController extends AdvancedController {
  static targets = ["tooltip", "swiper"];

  static values = {
    allSteps: String,
    activeIndex: {
      type: Number,
      default: 0,
    },
  };

  connect() {
    super.connect(...arguments);

    this.allSteps = JSON.parse(atob(this.allStepsValue));
    this.ids = [];
    for (const idx of this.allSteps.keys()) {
      const id = `step-${idx + 1}`;
      this.ids.push(id);
      document
        .getElementById(id)
        .addEventListener("click", this.onHotspotClick.bind(this));
      document
        .getElementById(id)
        .addEventListener("mouseenter", this.onMouseEnter.bind(this));
      document
        .getElementById(id)
        .addEventListener("mousemove", this.onMouseMove.bind(this));
      document
        .getElementById(id)
        .addEventListener("mouseleave", this.onMouseLeave.bind(this));
    }

    window.addEventListener("scroll", this.updateTooltipPosition.bind(this));

    if (this.ids) {
      this.currentTarget = document.getElementById(
        this.ids[this.activeIndexValue]
      );
      this.highlightCurrentSegment(this.ids[this.activeIndexValue]);
    }
    this.breakpoints = new Breakpoints();

    this.isTouchDevice = false;
    window.addEventListener("touchstart", () => {
      this.isTouchDevice = true;
    });
  }

  swiperTargetConnected() {
    const config = {
      modules: [Pagination, EffectFade, Autoplay],
      slidesPerView: 1,
      effect: "fade",
      allowTouchMove: true,
      fadeEffect: {
        crossFade: true,
      },
      speed: 500,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: this.element.querySelector(".swiper-pagination"),
        bulletActiveClass: "current",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      },
      navigation: {
        prevEl: this.element.querySelector(".swiper-button-prev"),
        nextEl: this.element.querySelector(".swiper-button-next"),
      },
      on: {
        activeIndexChange: (swiper) => {
          this.activeIndexValue = swiper.activeIndex;
          this.resetCurrentSegment();
          this.currentTarget = document.getElementById(
            this.ids[swiper.activeIndex]
          );
          this.highlightCurrentSegment(this.ids[swiper.activeIndex]);
        },
      },
    };

    this.swiper = new Swiper(this.swiperTarget, config);
  }

  async onHotspotClick(e) {
    const clickedId = e.currentTarget.getAttribute("id");
    if (this.ids.includes(clickedId)) {
      this.resetCurrentSegment();
      this.currentTarget = e.currentTarget;
      this.highlightCurrentSegment(clickedId);
      const index = this.ids.indexOf(clickedId);
      this.swiper.slideTo(index);
    }
  }

  onMouseEnter(e) {
    if (this.isTouchDevice) return;
    this.tooltipTarget.style.display = "block";
    this.tooltipTarget.style.position = "fixed";

    const enteredId = e.currentTarget.getAttribute("id");
    const index = this.ids.indexOf(enteredId);

    this.tooltipTarget.innerHTML = this.allSteps[index].tooltip;

    this.lastMouseY = e.clientY;
    this.updateTooltipPosition(e);
  }

  onMouseMove(e) {
    if (this.isTouchDevice) return;
    this.lastMouseY = e.clientY;
    this.updateTooltipPosition(e);
  }

  onMouseLeave(e) {
    if (this.isTouchDevice) return;
    this.tooltipTarget.style.display = "none";
  }

  updateTooltipPosition(e) {
    const boundingClientRect =
      this.tooltipTarget.parentElement.getBoundingClientRect();
    this.tooltipTarget.style.top = `${e.clientY - this.tooltipTarget.offsetHeight
      }px`;
    this.tooltipTarget.style.left = `${e.clientX - this.tooltipTarget.offsetWidth / 2
      }px`;
  }

  highlightCurrentSegment(clickedId) {
    this.currentTarget.classList.add("-active");
    const activeSlideIndex = this.ids.indexOf(clickedId);
    // for (let i = 0; i < activeSlideIndex; i++) {
    //   document.querySelector(`#${this.ids[i]}`).classList.add('-highlighted')

    // }

    // for (let i = activeSlideIndex; i < this.ids.length; i++) {
    //   document.querySelector(`#${this.ids[i]}`).classList.remove('-highlighted')

    // }
  }

  resetCurrentSegment() {
    if (this.currentTarget) {
      this.currentTarget.classList.remove("-active");
      this.currentTarget = null;
    }
  }
}
